module.exports = __webpack_public_path__ + "media/images/gallery/emission_nebulae/M_42/M_42_vis-9f3178e851ed58c54bff2f13bbb8b613.jpg";